import moment from "moment";

export function getDateFromInput({ dd, mm, yyyy }) {
  return moment(`${yyyy}-${mm}-${dd}`, "YYYY-MM-DD", true);
}

export function isDateInputEmpty({ dd, mm, yyyy }) {
  return [dd, mm, yyyy].every(
    (part) =>
      part === undefined || part === null || `${part}`.trim() === "",
  );
}

export function isDateInputValid({ dd, mm, yyyy }) {
  // Date of birth is optional, so a fully empty date is valid. A partially
  // or fully entered date is still checked for a real, past date.
  if (isDateInputEmpty({ dd, mm, yyyy })) {
    return true;
  }
  const date = getDateFromInput({ dd, mm, yyyy });
  const hasDatePassed = moment() > date;
  return date.isValid() && hasDatePassed;
}
